import React, { useEffect, useState } from 'react';
import axios from "axios"

// 記事表示用の関数コンポーネント
function Contents(props: { posts: any; }) {
  // props.postsで記事を取得
  var posts = props.posts;
  if(posts) {
    // map で配列を展開し、rowsに結果を格納
    const rows = posts.map((post: { link: string | undefined; _embedded: { [x: string]: { source_url: string | undefined; }[]; }; title: { [x: string]: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; }; }) =>
      <a href={post.link} className='entry-card-wrap a-wrap border-element cf fadeIn fadeIn-left'>
        <article className="entry-card">
          <figure className="entry-card-thumb card-thumb e-card-thumb">
            <img src={post._embedded["wp:featuredmedia"][0].source_url} alt="wordpress"></img>
          </figure>
          <div className="entry-card-content card-content e-card-content">
            <p className="entry-card-title card-title e-card-title">
              {post.title['rendered']}
            </p>
          </div>
        </article>
      </a>
    );
    return (
      <div>
        {rows}
      </div>
    )
  } else {
    return null
  }
}

// ローディング表示用の関数コンポーネント
function Loading() {
  return (
    <div className="sk-chase sk-center">
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
    </div>
  )
}



const WordpressAPI = () => {
    
    // 状態管理の変数と関数を定義
    const [post, setPost] = useState([]);
    const [load, setLoad] = useState(false);

    const [ids, setIds] = useState("id");
    const [title, setTitle] = useState();
    const [date, setDate] = useState();
    const [link, setLink] = useState();
    const [content, setContent] = useState();
    
    const [data, setData] = useState([]);

    const [APIdata, setAPIdata] = useState([]);

    // レンダー後のイベントを定義
    useEffect(() => {

        fetch(
            'https://fulufulu.jp/wp_kondousome/wp-json/wp/v2/posts'
        ).then(response => response.json())
        .then(data => {
            // 取得した記事のデータを格納
            setPost(data);

            setAPIdata(data);
            
            console.log(data);
            console.log(data[0].id);
            console.log(data[0].title.rendered);
            console.log(data[0].date);
            console.log(data[0].link);

            setIds(data[0].id);
            setTitle(data[2].title.rendered);
            setDate(data[2].date);
            setLink(data[0].link);
            setContent(data[0].content);
        })
        .catch(console.error);

        }, []);

        useEffect(() => {
        axios
            .get("https://fulufulu.jp/wp_kondousome/wp-json/wp/v2/posts")
            .then(response => setData(response.data))
            .catch(error => console.log(error));
        }, []);

    return(
        <>
          {/* 
            <p>{ids}</p>
            <p>{title}</p>
            <p>{date}</p>
          */}
        </>
    );
}
export default WordpressAPI;